import { CSSProperties } from 'react';
import styled from 'styled-components6';
import { ButtonBase } from './Button';
import { ReactNode } from 'react';

export const ButtonGroupButton = styled(ButtonBase)``;

const ButtonGroupContainer = styled.div`
    border-radius: var(--rwl-radius-lg);
    background-color: var(--rwl-color-neutral-light);
    display: flex;
    flex-direction: row;
    gap: 1px;
    overflow: hidden;
    color: var(--rwl-text-default);

    & a:hover {
        background-color: var(--rwl-color-neutral-light-hover);
    }
    & a:active {
        background-color: var(--rwl-color-neutral-light-active);
    }
`;

export const ButtonGroup = ({
    children,
    dark = false,
    style,
}: {
    children: ReactNode[] | ReactNode;
    dark?: boolean;
    style?: CSSProperties;
}) => {
    return (
        <ButtonGroupContainer
            data-theme={dark ? 'dark' : 'light'}
            style={style}
        >
            {children}
        </ButtonGroupContainer>
    );
};
